/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      username
      email
      password
      phone
      ssn
      firstName
      lastName
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      username
      email
      password
      phone
      ssn
      firstName
      lastName
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser($input: DeleteUserInput!) {
    deleteUser(input: $input) {
      username
      email
      password
      phone
      ssn
      firstName
      lastName
      __typename
    }
  }
`;
export const createUserInfo = /* GraphQL */ `
  mutation CreateUserInfo($input: CreateUserInfoInput!) {
    createUserInfo(input: $input) {
      ssn
      accNum
      alerus360id
      cif
      dateOfBirth
      __typename
    }
  }
`;
export const updateUserInfo = /* GraphQL */ `
  mutation UpdateUserInfo($input: UpdateUserInfoInput!) {
    updateUserInfo(input: $input) {
      ssn
      accNum
      alerus360id
      cif
      dateOfBirth
      __typename
    }
  }
`;
export const deleteUserInfo = /* GraphQL */ `
  mutation DeleteUserInfo($input: DeleteUserInfoInput!) {
    deleteUserInfo(input: $input) {
      ssn
      accNum
      alerus360id
      cif
      dateOfBirth
      __typename
    }
  }
`;
export const updateUserAtts = /* GraphQL */ `
  mutation UpdateUserAtts(
    $username: String
    $accessToken: String
    $newAtts: [UpdateUserAttributeInput]
  ) {
    updateUserAtts(
      username: $username
      accessToken: $accessToken
      newAtts: $newAtts
    ) {
      Username
      UserAttributes {
        Name
        Value
        __typename
      }
      __typename
    }
  }
`;
export const updateUserPassword = /* GraphQL */ `
  mutation UpdateUserPassword(
    $username: String
    $accessToken: String
    $password: String
  ) {
    updateUserPassword(
      username: $username
      accessToken: $accessToken
      password: $password
    ) {
      Username
      UserAttributes {
        Name
        Value
        __typename
      }
      __typename
    }
  }
`;
export const respondToChallenge = /* GraphQL */ `
  mutation RespondToChallenge(
    $username: String
    $password: String
    $session: String
  ) {
    respondToChallenge(
      username: $username
      password: $password
      session: $session
    )
  }
`;
export const updateUserMigration = /* GraphQL */ `
  mutation UpdateUserMigration(
    $username: String
    $password: String
    $newAtts: [UpdateUserAttributeInput]
  ) {
    updateUserMigration(
      username: $username
      password: $password
      newAtts: $newAtts
    ) {
      uniqueEmail
      passwordChangeSuccess
      attChangeSuccess
      idToken
      accessToken
      __typename
    }
  }
`;
export const updateSignUpUser = /* GraphQL */ `
  mutation UpdateSignUpUser(
    $username: String
    $password: String
    $newAtts: [UpdateUserAttributeInput]
  ) {
    updateSignUpUser(
      username: $username
      password: $password
      newAtts: $newAtts
    ) {
      a360idSuccess
      cifSuccess
      idToken
      accessToken
      __typename
    }
  }
`;
export const confirmUserDetails = /* GraphQL */ `
  mutation ConfirmUserDetails(
    $token: String
    $product: String
    $lastName: String
    $accNum: Int
    $ssn: Int
    $dob: Int
  ) {
    confirmUserDetails(
      token: $token
      product: $product
      lastName: $lastName
      accNum: $accNum
      ssn: $ssn
      dob: $dob
    ) {
      a360id
      username
      preferredName
      first
      last
      email
      phones
      address1
      address2
      city
      state
      zip
      primary
      allowText
      cif
      lastReview
      blocked
      defaultMfa
      totpEnabled
      totpDevices
      lastChallenge
      birthdate
      status
      passwordReset
      subUsers
      __typename
    }
  }
`;
export const createUserLog = /* GraphQL */ `
  mutation CreateUserLog(
    $username: String
    $log: String
    $app: String
    $info: String
  ) {
    createUserLog(username: $username, log: $log, app: $app, info: $info)
  }
`;
export const updateMyProfile = /* GraphQL */ `
  mutation UpdateMyProfile($func: String, $arguments: String) {
    updateMyProfile(func: $func, arguments: $arguments) {
      a360id
      username
      preferredName
      first
      last
      email
      phones
      address1
      address2
      city
      state
      zip
      primary
      allowText
      cif
      lastReview
      blocked
      defaultMfa
      totpEnabled
      totpDevices
      lastChallenge
      birthdate
      status
      passwordReset
      subUsers
      __typename
    }
  }
`;
